import type { LoadRequest, NpawPluginConfig } from "@foundation-player/api";
import { Media } from "./media_player.types";
import { Plugin } from "./media_plugin.js";

/**
 * For further information on the Npaw plugin, please also refer
 * to the corresponding API documentation in the Foundation Player documentation:
 *
 * @see https://docs.player.foundation/v2/api/type/load-request/#plugins
 * @see https://docs.player.foundation/v2/api/type/load-request/#foundationpluginnpaw
 * @see https://docs.player.foundation/v2/api/type/npaw-plugin-config/
 */
export class PluginNpaw extends Plugin {
  public constructor(media: Media) {
    super(media);
  }

  public isEnabled(): boolean {
    return true;
  }

  public addFoundationLoadRequestPlugins(): LoadRequest["plugins"] {
    const npawPluginConfig: NpawPluginConfig = {
      enabled: true,
      userType: this.media.userPlus ? "paid" : "free",
      title: this.media.tracking?.staticTitle,
      channelName: this.media.scope,
    };
    return {
      "foundation.plugin.npaw": npawPluginConfig,
    };
  }
}
